var _g, _g2, _path, _ellipse, _g3, _rect, _rect2, _rect3, _path2, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _path3, _path4, _circle, _circle2, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _path5, _path6, _path7, _path8, _rect4, _g36, _g37, _rect5, _path9, _g38, _path10, _path11, _path12, _path13, _g39, _g40, _path14, _path15, _path16, _path17, _g41, _g42, _g43, _path18, _path19, _g44, _path20, _path21, _line, _line2, _line3, _path22, _path23, _path24, _path25, _g45, _path26, _g46, _path27, _path28, _g47, _path29, _path30, _g48, _g49, _g50, _g51, _g52, _g53, _g54;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 764.723,
    height: 645.772,
    viewBox: "0 0 764.723 645.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "digital_marketing",
    "data-name": "digital marketing",
    transform: "translate(-1015.277 -2642)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M2952.139,1552.3c0,173.758-41.754,286.338-280.792,315.268-88.688,10.734-101.18-138.827-199.228-137.347-143.812,2.17-166.161-100.895-157.415-141.036,27.717-127.223,235.469-438.064,358.558-346.078C2914.243,1423.2,2952.139,1378.547,2952.139,1552.3Z",
    transform: "translate(-1229.47 1415.646)",
    fill: "#0095ff",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M3008.85,1563.513c0,173.758-210.86,233.25-443.067,302.973-142.488,42.784-317.775-152.174-295.427-300.8,28.567-189.978,217.979-381.651,341.068-289.665C2852.406,1456.109,3008.85,1389.756,3008.85,1563.513Z",
    transform: "translate(-1228.851 1415.286)",
    fill: "#0095ff",
    opacity: 0.09
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885",
    transform: "translate(698.05 2567.249)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(361.19 597.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2151",
    "data-name": "Path 2151",
    d: "M336.984,361.172c0,8.975,113.9,16.257,254.42,16.257,140.5,0,254.4-7.282,254.4-16.257S731.9,344.91,591.4,344.91C450.885,344.91,336.984,352.19,336.984,361.172Z",
    transform: "translate(-336.984 -344.91)",
    fill: "#cdccff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2152",
    "data-name": "Path 2152",
    d: "M477.737,366.7c0,5.619-28.915,10.173-64.584,10.173s-64.584-4.554-64.584-10.173,28.915-10.173,64.584-10.173S477.737,361.085,477.737,366.7Z",
    transform: "translate(38.7 267.255)",
    fill: "#cdccff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 108.364,
    cy: 8.049,
    rx: 108.364,
    ry: 8.049,
    transform: "translate(837.71 628.034)",
    fill: "#cdccff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    transform: "translate(367.17 454.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2153",
    "data-name": "Path 2153",
    d: "M350.581,302.589l-4.161,58.278h55.591l-3.83-58.387Z",
    transform: "translate(-331.158 -254.669)",
    fill: "#d7d7ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    transform: "translate(30.45 51.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    transform: "translate(0 0.043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2154",
    "data-name": "Path 2154",
    d: "M353.167,305.7v0a1.783,1.783,0,0,1,1.9-1.616h0a1.635,1.635,0,1,1,.007,3.226h0A1.785,1.785,0,0,1,353.167,305.7Zm1.907-1a1.032,1.032,0,1,0,0,2h0a1.032,1.032,0,1,0,0-2Zm-1.605,1h0Z",
    transform: "translate(-353.167 -304.085)",
    fill: "#eae6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    transform: "translate(18.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2155",
    "data-name": "Path 2155",
    d: "M361.586,305.682l.308,0-.308,0a1.487,1.487,0,0,1,.446-1.044,2.063,2.063,0,0,1,1.456-.572h.007a1.777,1.777,0,0,1,1.9,1.607,1.483,1.483,0,0,1-.576,1.162,2.084,2.084,0,0,1-1.326.455h0A1.783,1.783,0,0,1,361.586,305.682Zm1.9-1a1.444,1.444,0,0,0-1.02.394.859.859,0,0,0-.268.605h0a1.18,1.18,0,0,0,1.294,1h0a1.479,1.479,0,0,0,.937-.315.888.888,0,0,0,.351-.684,1.175,1.175,0,0,0-1.29-1Z",
    transform: "translate(-361.586 -304.066)",
    fill: "#eae6ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2156",
    "data-name": "Path 2156",
    d: "M363.315,316.892c.178,0,.358,0,.54-.009,3.482-.117,6.139-1.238,7.895-3.334,2.9-3.469,2.247-8.307,2.217-8.511a.609.609,0,0,0-.7-.52.616.616,0,0,0-.524.7c.007.045.606,4.511-1.947,7.552-1.52,1.81-3.872,2.782-6.985,2.886q-4.521.135-6.758-2.359c-2.715-3.021-2.046-7.987-2.039-8.036a.616.616,0,0,0-1.22-.176c-.031.227-.759,5.574,2.339,9.029C357.791,315.957,360.2,316.892,363.315,316.892Z",
    transform: "translate(-352.498 -303.513)",
    fill: "#eae6ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2157",
    "data-name": "Path 2157",
    d: "M363.575,309.847l-6.643,43.329,60.356-.142-6.112-43.3Z",
    transform: "translate(-318.007 -245.592)",
    fill: "#bdc6f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2158",
    "data-name": "Path 2158",
    d: "M356.757,342.284A12.242,12.242,0,1,0,369,354.526,12.242,12.242,0,0,0,356.757,342.284Zm0,17.926a5.683,5.683,0,1,1,5.707-5.684A5.681,5.681,0,0,1,356.757,360.21Z",
    transform: "translate(-333.542 -204.87)",
    fill: "#8784ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M355.864,342.284a12.242,12.242,0,1,0,12.242,12.242A12.244,12.244,0,0,0,355.864,342.284Zm0,17.926a5.683,5.683,0,1,1,5.707-5.684A5.681,5.681,0,0,1,355.864,360.21Z",
    transform: "translate(-334.661 -204.87)",
    fill: "#9aa3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M387.481,342.284a12.242,12.242,0,1,0,12.241,12.242A12.244,12.244,0,0,0,387.481,342.284Zm0,17.926a5.683,5.683,0,1,1,5.709-5.684A5.679,5.679,0,0,1,387.481,360.21Z",
    transform: "translate(-295.103 -204.87)",
    fill: "#8784ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M386.586,342.284a12.242,12.242,0,1,0,12.242,12.242A12.242,12.242,0,0,0,386.586,342.284Zm0,17.926a5.683,5.683,0,1,1,5.709-5.684A5.679,5.679,0,0,1,386.586,360.21Z",
    transform: "translate(-296.221 -204.87)",
    fill: "#9aa3f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M459.806,281.241H423.023a11.2,11.2,0,0,0-9.511,5.281l-22.232,35.7",
    transform: "translate(-275.034 -281.241)",
    fill: "none",
    stroke: "#9aa3f4",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2163",
    "data-name": "Path 2163",
    d: "M357.059,367.982h82.2a8.913,8.913,0,0,0,8.8-7.5l8.5-53.056a8.912,8.912,0,0,0-8.8-10.321H348.554a8.913,8.913,0,0,0-8.8,10.321l8.507,53.056A8.909,8.909,0,0,0,357.059,367.982Z",
    transform: "translate(-339.64 -261.395)",
    fill: "none",
    stroke: "#9aa3f4",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    y2: 70.878,
    transform: "translate(58.517 35.71)",
    fill: "none",
    stroke: "#9aa3f4",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_41",
    "data-name": "Line 41",
    x1: 108.751,
    transform: "translate(4.141 71.149)",
    fill: "none",
    stroke: "#9aa3f4",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_42",
    "data-name": "Line 42",
    x1: 7.034,
    y2: 70.878,
    transform: "translate(83.946 35.71)",
    fill: "none",
    stroke: "#9aa3f4",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_43",
    "data-name": "Line 43",
    x2: 6.493,
    y2: 70.878,
    transform: "translate(27.677 35.71)",
    fill: "none",
    stroke: "#9aa3f4",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2164",
    "data-name": "Path 2164",
    d: "M443.813,327.158l13.318,19.8A8.114,8.114,0,0,1,450.4,359.6H341.48",
    transform: "translate(-337.339 -223.794)",
    fill: "none",
    stroke: "#9aa3f4",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824",
    transform: "translate(508.657 295.766)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 112.754,
    height: 30.332,
    transform: "translate(138.465 271.304)",
    fill: "#4a41a3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_142",
    "data-name": "Rectangle 142",
    width: 390.871,
    height: 281.206,
    rx: 9.387,
    transform: "translate(0)",
    fill: "#5851bc"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143",
    "data-name": "Rectangle 143",
    width: 367.847,
    height: 243.972,
    rx: 5.768,
    transform: "translate(10.918 10.253)",
    fill: "#c4c3fc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_144",
    "data-name": "Rectangle 144",
    d: "M7.322,0H202.36a7.322,7.322,0,0,1,7.322,7.322v11.8a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V7.322A7.322,7.322,0,0,1,7.322,0Z",
    transform: "translate(90 298.998)",
    fill: "#5851bc"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    transform: "translate(98.763 27.104)",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 257.385,
    height: 173.007,
    rx: 5.01,
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(98.763 27.104)",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(17.057 26.162)"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(7.404 100.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_146",
    "data-name": "Rectangle 146",
    width: 11.211,
    height: 28.147,
    fill: "#fca70c"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607",
    transform: "translate(32.668 75.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 11.212,
    height: 52.856,
    fill: "#b1affd"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(57.933 80.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148",
    "data-name": "Rectangle 148",
    width: 11.211,
    height: 47.39,
    fill: "#fca70c"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(83.197 54.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149",
    "data-name": "Rectangle 149",
    width: 11.212,
    height: 74.147,
    fill: "#b1affd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(32.668 75.509)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_150",
    "data-name": "Rectangle 150",
    width: 5.146,
    height: 52.856,
    opacity: 0.26
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(7.404 100.218)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_151",
    "data-name": "Rectangle 151",
    width: 5.146,
    height: 28.147,
    opacity: 0.26
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    transform: "translate(83.197 54.218)",
    opacity: 0.62,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_152",
    "data-name": "Rectangle 152",
    width: 5.146,
    height: 74.147,
    opacity: 0.26
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(57.933 80.975)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 5.146,
    height: 47.39,
    opacity: 0.26
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(0 29.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2165",
    "data-name": "Path 2165",
    d: "M554.284,354.324H453.943V247.48h1.531V352.794h98.81Z",
    transform: "translate(-453.943 -247.48)",
    fill: "#d5dbda"
  }))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631",
    transform: "translate(9.284 38.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2166",
    "data-name": "Path 2166",
    d: "M459.09,300.228l-1.022-1.139,26.248-23.569,24.313,5.282,26.327-29.309,1.139,1.023-26.922,29.97-24.416-5.3Z",
    transform: "translate(-458.068 -251.492)",
    fill: "#d5dbda"
  }))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(81.95 33.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M497.771,259.252l-7.423-7.119,9.583-2.564Z",
    transform: "translate(-490.348 -249.569)",
    fill: "#d5dbda"
  }))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647",
    transform: "translate(109.843 98.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_154",
    "data-name": "Rectangle 154",
    width: 7.699,
    height: 7.699,
    fill: "#b1affd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(0 13.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 7.699,
    height: 7.7,
    fill: "#fca70c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(9.821 16.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 24.406,
    height: 4.375,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646",
    transform: "translate(9.821 3.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 24.406,
    height: 4.375,
    fill: "#efefef"
  })))))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660",
    transform: "translate(155.123 98.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_158",
    "data-name": "Rectangle 158",
    width: 7.7,
    height: 7.699,
    fill: "#b1affd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653",
    transform: "translate(0 13.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_159",
    "data-name": "Rectangle 159",
    width: 7.7,
    height: 7.7,
    fill: "#fca70c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(9.821 16.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_160",
    "data-name": "Rectangle 160",
    width: 24.406,
    height: 4.375,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659",
    transform: "translate(9.821 3.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161",
    "data-name": "Rectangle 161",
    width: 24.406,
    height: 4.375,
    fill: "#efefef"
  })))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673",
    transform: "translate(195.897 98.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 7.699,
    height: 7.699,
    fill: "#b1affd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666",
    transform: "translate(0 13.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_163",
    "data-name": "Rectangle 163",
    width: 7.699,
    height: 7.7,
    fill: "#fca70c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(9.82 16.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_164",
    "data-name": "Rectangle 164",
    width: 16.061,
    height: 4.375,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(9.82 3.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 16.061,
    height: 4.375,
    fill: "#efefef"
  })))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(111.284 24.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 110.495,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_167",
    "data-name": "Rectangle 167",
    width: 221.779,
    height: 4.598,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    transform: "translate(110.952 30.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_168",
    "data-name": "Rectangle 168",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(110.952 18.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(110.952 37.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(110.952 43.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 110.827,
    height: 2.008,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(110.952 49.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(110.952 55.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(110.952 62.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(110.952 68.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(124.521 74.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 97.258,
    height: 2.009,
    fill: "#efefef"
  }))))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2168",
    "data-name": "Path 2168",
    d: "M692.472,222.856H457.644a11.278,11.278,0,0,0-11.278,11.278v9.871H703.75v-9.871A11.278,11.278,0,0,0,692.472,222.856Z",
    transform: "translate(-446.366 -222.856)",
    fill: "#7a7ae5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2169",
    "data-name": "Path 2169",
    d: "M549.612,229.532a3.252,3.252,0,1,1-3.251-3.251A3.251,3.251,0,0,1,549.612,229.532Z",
    transform: "translate(-325.332 -218.571)",
    fill: "#cfcfff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 3.252,
    cy: 3.252,
    r: 3.252,
    transform: "translate(231.031 7.71)",
    fill: "#cfcfff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 3.252,
    cy: 3.252,
    r: 3.252,
    transform: "translate(244.285 7.71)",
    fill: "#cfcfff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_823",
    "data-name": "Group 823",
    transform: "translate(30.392 58.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(0 6.737)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 257.384,
    height: 173.007,
    rx: 5.01,
    fill: "#c4c3fc",
    opacity: 0.55,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715",
    transform: "translate(5.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 257.384,
    height: 173.007,
    rx: 5.01,
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822",
    transform: "translate(22.278 26.162)"
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    transform: "translate(7.404 100.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 11.211,
    height: 28.147,
    fill: "#fca70c"
  }))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    transform: "translate(32.668 75.509)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 11.212,
    height: 52.856,
    fill: "#b1affd"
  }))))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724",
    transform: "translate(57.933 80.975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 11.211,
    height: 47.39,
    fill: "#fca70c"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727",
    transform: "translate(83.197 54.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 11.212,
    height: 74.147,
    fill: "#b1affd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730",
    transform: "translate(32.668 75.509)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 5.146,
    height: 52.856,
    opacity: 0.26
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733",
    transform: "translate(7.404 100.218)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 5.146,
    height: 28.147,
    opacity: 0.26
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736",
    transform: "translate(83.197 54.218)",
    opacity: 0.62,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 5.146,
    height: 74.147,
    opacity: 0.26
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739",
    transform: "translate(57.933 80.975)",
    opacity: 0.15,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 5.146,
    height: 47.39,
    opacity: 0.26
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(0 38.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2170",
    "data-name": "Path 2170",
    d: "M526.232,363.027H425.891v-97.3h1.531V361.5h98.81Z",
    transform: "translate(-425.891 -265.727)",
    fill: "#d5dbda"
  }))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745",
    transform: "translate(9.284 38.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2171",
    "data-name": "Path 2171",
    d: "M431.037,314.235l-1.023-1.139,26.248-23.569,24.313,5.282L506.9,265.5l1.139,1.023-26.922,29.97-24.416-5.3Z",
    transform: "translate(-430.015 -265.5)",
    fill: "#d5dbda"
  }))))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748",
    transform: "translate(81.95 33.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2172",
    "data-name": "Path 2172",
    d: "M469.718,273.259l-7.423-7.119,9.584-2.564Z",
    transform: "translate(-462.295 -263.576)",
    fill: "#d5dbda"
  }))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761",
    transform: "translate(109.843 98.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 7.7,
    height: 7.699,
    fill: "#b1affd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754",
    transform: "translate(0 13.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 7.7,
    height: 7.7,
    fill: "#fca70c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757",
    transform: "translate(9.821 16.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 24.407,
    height: 4.375,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760",
    transform: "translate(9.821 3.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 24.407,
    height: 4.375,
    fill: "#efefef"
  })))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774",
    transform: "translate(155.123 98.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 7.7,
    height: 7.699,
    fill: "#b1affd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767",
    transform: "translate(0 13.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 7.7,
    height: 7.7,
    fill: "#fca70c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770",
    transform: "translate(9.821 16.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 24.406,
    height: 4.375,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773",
    transform: "translate(9.821 3.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 24.406,
    height: 4.375,
    fill: "#efefef"
  })))))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787",
    transform: "translate(195.898 98.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 7.7,
    height: 7.699,
    fill: "#b1affd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780",
    transform: "translate(0 13.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 7.7,
    height: 7.7,
    fill: "#fca70c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783",
    transform: "translate(9.821 16.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 16.061,
    height: 4.375,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786",
    transform: "translate(9.821 3.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 16.061,
    height: 4.375,
    fill: "#efefef"
  })))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    "data-name": "Group 821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790",
    transform: "translate(111.284 24.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 110.495,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 221.779,
    height: 4.598,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796",
    transform: "translate(110.952 30.904)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799",
    transform: "translate(110.952 18.409)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_802",
    "data-name": "Group 802",
    transform: "translate(110.952 37.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_801",
    "data-name": "Group 801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_800",
    "data-name": "Group 800"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_805",
    "data-name": "Group 805",
    transform: "translate(110.952 43.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_804",
    "data-name": "Group 804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 110.827,
    height: 2.008,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808",
    transform: "translate(110.952 49.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_811",
    "data-name": "Group 811",
    transform: "translate(110.952 55.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_810",
    "data-name": "Group 810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814",
    transform: "translate(110.952 62.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_817",
    "data-name": "Group 817",
    transform: "translate(110.952 68.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_816",
    "data-name": "Group 816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_815",
    "data-name": "Group 815"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 110.827,
    height: 2.009,
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820",
    transform: "translate(124.521 74.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_819",
    "data-name": "Group 819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 97.258,
    height: 2.009,
    fill: "#efefef"
  }))))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2173",
    "data-name": "Path 2173",
    d: "M664.42,236.863H429.592a11.278,11.278,0,0,0-11.278,11.278v9.871H675.7v-9.871A11.278,11.278,0,0,0,664.42,236.863Z",
    transform: "translate(-413.092 -236.863)",
    fill: "#a4a4f7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2174",
    "data-name": "Path 2174",
    d: "M521.559,243.539a3.252,3.252,0,1,1-3.253-3.251A3.253,3.253,0,0,1,521.559,243.539Z",
    transform: "translate(-292.057 -232.578)",
    fill: "#cfcfff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2175",
    "data-name": "Path 2175",
    d: "M527.449,243.539a3.253,3.253,0,1,1-3.253-3.251A3.253,3.253,0,0,1,527.449,243.539Z",
    transform: "translate(-284.692 -232.578)",
    fill: "#cfcfff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2176",
    "data-name": "Path 2176",
    d: "M533.334,243.539a3.252,3.252,0,1,1-3.25-3.251A3.252,3.252,0,0,1,533.334,243.539Z",
    transform: "translate(-277.326 -232.578)",
    fill: "#cfcfff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2177",
    "data-name": "Path 2177",
    d: "M607.112,210.9H546.839q.618,29.316,1,58.639c.038,2.989,0,6.073-1.09,8.836l-.092,0c-.8-.043-.446.207-.72,1.637,0,.02-.013.045-.018.065-2.438,3.98-7.194,6.157-11.825,7.181a1.174,1.174,0,0,0,.074.646,1.481,1.481,0,0,0-.466,1.821c.281.653,3.746,1.538,8.451,1.031a22.443,22.443,0,0,0,5.22-1.447A8.1,8.1,0,0,0,549.29,288a6.641,6.641,0,0,0,1.763-.425l.191.18,5.394-2.348s-.59-3.4-1.056-5.175a3.081,3.081,0,0,0-.356-.833,247.215,247.215,0,0,0,10.582-37.614c-.981,15.877-6.686,48.129-7.109,49.238a8.278,8.278,0,0,1-6.855,4.813c-1.276.106-7.555-.257-6.877,2.632.162.689,3.422,2.163,8.144,2.478a22.372,22.372,0,0,0,5.391-.52,10,10,0,0,0,3.361-1.83l.727.97,5.718-1.378s-.009-1.488-.045-3.28a7.3,7.3,0,0,0-1.225-3.487l.079-3.253,3.169-.374s6.366-20.591,9.389-27.594a61.661,61.661,0,0,0,3.422-8.773c.93-3.572,1.017-7.3,1.312-10.976a97.056,97.056,0,0,1,3.683-19.816,2.922,2.922,0,0,1,.538-1.157,3.071,3.071,0,0,1,2.085-.727c8.1-.743,11.816.635,16.885-.936,6.684-2.073,7.393-5.106,7.719-5.252A21.034,21.034,0,0,0,607.112,210.9Z",
    transform: "translate(-238.521 -210.706)",
    fill: "#5851bc",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2178",
    "data-name": "Path 2178",
    d: "M601.4,309.684v-69.9c-10.425,13.646-20.739,25.876-31.164,39.523-4.525,5.918-22.239,25.53-10.155,33.4,3.084,2.008,8.455,1.916,11.138,2.1,9.639.684,19.19-1.983,28.562-4.633C600.317,310.026,600.859,309.862,601.4,309.684Z",
    transform: "translate(-210.527 -174.574)",
    fill: "#5851bc",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M596.614,281.405l-5.8.448-.11-.329-4.516.349-1.359-3.843a5.829,5.829,0,0,0-5.693-3.613,3.111,3.111,0,0,0-2.886,4.315c.236.664.9,2.528,1.348,3.8l-4.752.367.1.331-9.788.759c-1.547.009-3.831,2.006-3.336,3.4l.079.2a2.023,2.023,0,0,0,.045.362l8.466,23.889L568.2,412.469h9.826l18.59-72.274Zm-15.269-.747a3.268,3.268,0,0,1-3.194-2.028,1.743,1.743,0,0,1,1.619-2.42,3.268,3.268,0,0,1,3.192,2.026A1.744,1.744,0,0,1,581.345,280.658Z",
    transform: "translate(-205.744 -131.263)",
    fill: "#5851bc",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M427.059,261.511c-2.186,2.411-4.763,7.546-5.812,9.756-1.108,2.179-2.305,3.413-5.421,4.876-4.3,1.967-8.908,3.849-13.333,5.59v11.415c9-5.414,17.151-10.465,17.288-10.519,6.882,2.632,12.638-3.091,14.484-7.217.828-1.853-.414-2.609-.47-3.489-.032-.459.561-3.138.47-3.482-.538-2.411-7.01-.3-6.472-1.452a8.224,8.224,0,0,1,2.695-4.036c3.17-2.163,5.6-4.563,5.6-5.472C436.084,255.912,427.809,260.687,427.059,261.511Z",
    transform: "translate(-402.493 -152.827)",
    fill: "#5851bc",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828",
    transform: "translate(881.93 462.464)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 151.971,
    height: 175.744,
    rx: 6.949,
    transform: "translate(0 0)",
    fill: "#a2a7f4"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    "data-name": "Group 826",
    transform: "translate(14.058 18.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 128.525,
    height: 36.098,
    rx: 1.773,
    fill: "#9090f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(0 48.899)",
    fill: "#9090f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(47.739 48.899)",
    fill: "#9090f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(95.477 48.899)",
    fill: "#9090f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(0 85.735)",
    fill: "#9090f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(47.739 85.735)",
    fill: "#9090f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_217",
    "data-name": "Rectangle 217",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(0 122.571)",
    fill: "#9090f4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_218",
    "data-name": "Rectangle 218",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(47.739 122.571)",
    fill: "#9090f4"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_219",
    "data-name": "Rectangle 219",
    width: 33.048,
    height: 59.75,
    rx: 1.773,
    transform: "translate(95.477 85.735)",
    fill: "#9090f4"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827",
    transform: "translate(11.722 16.059)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M573.518,295.992A3.992,3.992,0,0,1,577.509,292H698.054a3.992,3.992,0,0,1,3.991,3.991v28.114a3.99,3.99,0,0,1-3.991,3.991H577.509",
    transform: "translate(-573.518 -292.001)",
    fill: "#e2deff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_220",
    "data-name": "Rectangle 220",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(0.001 48.899)",
    fill: "#e2deff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_221",
    "data-name": "Rectangle 221",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(47.739 48.899)",
    fill: "#e2deff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_222",
    "data-name": "Rectangle 222",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(95.478 48.899)",
    fill: "#e2deff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_223",
    "data-name": "Rectangle 223",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(0.001 85.734)",
    fill: "#e2deff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(47.739 85.734)",
    fill: "#e2deff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(0.001 122.57)",
    fill: "#e2deff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_226",
    "data-name": "Rectangle 226",
    width: 33.048,
    height: 22.914,
    rx: 1.773,
    transform: "translate(47.739 122.57)",
    fill: "#e2deff"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_227",
    "data-name": "Rectangle 227",
    width: 33.048,
    height: 59.75,
    rx: 1.773,
    transform: "translate(107.2 101.794)",
    fill: "#fca70c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M618.266,388.18V336.414a3.99,3.99,0,0,1,3.991-3.991h25.066a3.981,3.981,0,0,1,1.393.263,3.983,3.983,0,0,0-3.728-2.6H619.923a3.992,3.992,0,0,0-3.991,3.993v51.766a3.984,3.984,0,0,0,2.6,3.728A3.971,3.971,0,0,1,618.266,388.18Z",
    transform: "translate(-508.732 -228.293)",
    fill: "#f9c110"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M568.311,316.087l4.072,10.713h17.032s-1.182,46.321-1.256,55,7.145,68.584,7.145,68.584h9.864l-1.029-75.522L618.13,336.12s10.524,51.872,14.887,60.55,27.8,53.718,27.8,53.718h9.049L646.632,351.06l-9.977-34.514L586.36,293.038l-18.049,1.778",
    transform: "translate(-568.311 -274.644)",
    fill: "#5851bc",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833",
    transform: "translate(533.722 542.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M421.568,320.452l-7.94,82.263,78.017.017-7.546-82.42Z",
    transform: "translate(-413.627 -320.313)",
    fill: "#fca70c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831",
    transform: "translate(21.544 5.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829",
    transform: "translate(0 0.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M423.2,325.1h0a2.732,2.732,0,0,1,2.92-2.481h0a2.51,2.51,0,1,1,.009,4.95h0A2.733,2.733,0,0,1,423.2,325.1Zm2.922-1.537a1.582,1.582,0,1,0,0,3.061h0a1.582,1.582,0,1,0,0-3.061Zm-2.463,1.537h0Z",
    transform: "translate(-423.198 -322.617)",
    fill: "#5851bc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830",
    transform: "translate(29.077)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M436.115,325.069l.471,0-.471,0a2.265,2.265,0,0,1,.684-1.6,3.146,3.146,0,0,1,2.231-.878h.013a2.728,2.728,0,0,1,2.922,2.465,2.277,2.277,0,0,1-.885,1.783,3.207,3.207,0,0,1-2.033.7h0A2.735,2.735,0,0,1,436.115,325.069Zm2.918-1.537a2.21,2.21,0,0,0-1.565.6,1.311,1.311,0,0,0-.41.93h0a1.808,1.808,0,0,0,1.983,1.526h0a2.279,2.279,0,0,0,1.436-.484,1.366,1.366,0,0,0,.54-1.049,1.8,1.8,0,0,0-1.981-1.526Z",
    transform: "translate(-436.115 -322.588)",
    fill: "#5851bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832",
    transform: "translate(23.397 6.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M438.773,342.266c.272,0,.547,0,.831-.013,5.342-.178,9.416-1.9,12.109-5.115,4.457-5.324,3.449-12.746,3.4-13.059a.945.945,0,0,0-1.871.268c.009.07.93,6.922-2.989,11.589-2.332,2.778-5.938,4.268-10.717,4.428-4.626.137-8.072-1.062-10.369-3.617-4.164-4.637-3.14-12.257-3.129-12.334a.946.946,0,0,0-1.873-.268c-.047.347-1.164,8.552,3.588,13.856C430.3,340.832,434,342.266,438.773,342.266Z",
    transform: "translate(-424.021 -323.266)",
    fill: "#5851bc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841",
    transform: "translate(317.636 336.827)"
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M392.368,239.255c3.019,5.214.412,12.338,3.458,17.536,1.22,2.08,3.284,3.717,3.87,6.055a5.278,5.278,0,0,1-7.591,5.945,6.457,6.457,0,0,0-1.173-.581c-1.506-.441-2.87.9-4.165,1.781a6.356,6.356,0,0,1-5.484.97c-2.339-.783-3.786-3.14-4.565-5.481-2.179-6.542-.63-13.7,1.382-20.3,1.006-3.3,2.492-6.951,5.725-8.147",
    transform: "translate(-245.043 -219.076)",
    fill: "#5045af"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M456.1,274.943c.05.725,1.155,1.348.419,2.875-1.639,3.4-6.746,8.12-12.856,5.952-.266.095-33.749,19.449-36.328,19.449s-20.152-16.629-25.9-37.2c-1.371-4.91-.837-10.684,3.762-13.169a10.88,10.88,0,0,1,6.323,5.628c3.807,7.186,15.206,30.98,17.732,31.878,3.149-2.1,18.482-6.654,30.9-11.929,2.767-1.207,3.829-2.224,4.813-4.023.932-1.821,3.217-6.055,5.16-8.043.664-.68,8.012-4.615,8.012-3.323,0,.747-2.157,2.728-4.968,4.511a6.735,6.735,0,0,0-2.391,3.327c-.479.945,5.265-.79,5.743,1.2C456.6,272.354,456.075,274.565,456.1,274.943Z",
    transform: "translate(-238.646 -199.292)",
    fill: "#ffb9b0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M384.483,252.577a15.082,15.082,0,0,1,10,7.755,31.28,31.28,0,0,1,1.362,3.125c1.783,4.538,4.236,8.644,6.019,13.18-2.438,1.967-5.389,2.872-7.874,3.8a16.822,16.822,0,0,1-7.33.984,3.707,3.707,0,0,1-1.234-.272,4.063,4.063,0,0,1-1.283-1.1q-1.145-1.314-2.229-2.679a7.357,7.357,0,0,1-1.5-2.562,7.779,7.779,0,0,1,.351-3.991",
    transform: "translate(-239.272 -199.629)",
    fill: "#7762ef"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M385.217,258.382a1.553,1.553,0,0,0-.574-.488,1.04,1.04,0,0,0-1.2.533,2.763,2.763,0,0,0-.25,1.4,19.076,19.076,0,0,0,.855,5.432l-.57,9.569.013.02a16.794,16.794,0,0,0,6.855-1c1.036-.385,2.152-.783,3.278-1.238C392.47,267.216,388.794,262.648,385.217,258.382Z",
    transform: "translate(-235.625 -193.042)",
    fill: "#7762ef",
    opacity: 0.35,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2192",
    "data-name": "Path 2192",
    d: "M390.38,249.328s-.128,5.992.792,6.384a23.48,23.48,0,0,0,3.872,1.2l.061,12.4-16.532-2.492-11.373-6.33s11.821-3.919,11.924-5.1-.651-7.811-.651-7.811",
    transform: "translate(-255.627 -205.882)",
    fill: "#ffb9b0"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834",
    transform: "translate(105.968 132.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2193",
    "data-name": "Path 2193",
    d: "M368.1,341.151l-.009.047c-4.523,21.444-2.368,50.9-3.377,67.047.236.065,6.146.806,6.146.806s13.988-68.044,16.528-81.076a18.437,18.437,0,0,0,.322-2.524c.61-9.806-8.228-10.306-13.207-2.2a33.937,33.937,0,0,0-2.278,4.376c-.281.639-.542,1.288-.815,1.979l0,.023a63.845,63.845,0,0,0-2.193,6.846l-.052.248c-.207.687-.376,1.382-.542,2.08l-.034.158C368.406,339.679,368.253,340.4,368.1,341.151Z",
    transform: "translate(-364.71 -250.482)",
    fill: "#ffb9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2194",
    "data-name": "Path 2194",
    d: "M392.507,301.486c-.167,1.774-1.112,10.218-2.249,20.177-.97,8.374-2.033,17.813-2.861,25.289-.615,5.605-1.065,10.076-1.254,12.181a27.288,27.288,0,0,1-.5,3.62v.047c-2.13,9.792-8.894,10.362-13.009,8.09a8.223,8.223,0,0,1-1.562-1.065,5.257,5.257,0,0,1-1.751-2.886v-.023c-.259-2.013-.52-4.757-.756-8.021v-.047c-.022-.022-.022-.022-.022-.047l-.025-.07c-.5-6.364-.923-14.549-1.3-22.52-.448-9.795-.734-19.233-.8-24.555-.025-.308-.025-.592-.047-.876-.072-16.32,14.927-26.777,24.247-21.714a2.376,2.376,0,0,1,.331.164,3.509,3.509,0,0,0,.356.214c1.065.709,1.418,3.145,1.443,5.936C392.791,297.416,392.649,299.64,392.507,301.486Z",
    transform: "translate(-362.637 -287.783)",
    fill: "#ffb9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2195",
    "data-name": "Path 2195",
    d: "M369.879,323.6l-1.141-4.275c0,.022,0,.022.011.052a68.347,68.347,0,0,1-1.418,14.927l-.052.248c-.164.675-.335,1.393-.543,2.08l-.034.158a11.644,11.644,0,0,0-.484,2.19l-.009.047c-.013,1.938,4.115-6.67,5.06-8.682.117-.257.189-.4.189-.4l-1.116-4.484Z",
    transform: "translate(-362.833 -248.315)",
    fill: "#ffb9b0"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    "data-name": "Group 835",
    transform: "translate(132.978 131.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2196",
    "data-name": "Path 2196",
    d: "M382.2,344.985v.047c-.428,22.453,6.506,48.853,8.34,65.163.223.007,5.664-.727,5.664-.727s1.035-68.787,1.108-82.379a20.582,20.582,0,0,0-.137-2.591c-1.114-9.9-9.148-8.205-12.253,1.092a40.178,40.178,0,0,0-1.308,4.919c-.142.707-.268,1.416-.394,2.17l0,.025c-.378,2.312-.651,4.772-.81,7.352l0,.261c-.07.734-.1,1.468-.135,2.2l0,.167C382.233,343.443,382.219,344.2,382.2,344.985Z",
    transform: "translate(-369.858 -249.507)",
    fill: "#ffb9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2197",
    "data-name": "Path 2197",
    d: "M393.721,373.787a5.846,5.846,0,0,1-1.578-.689,4.5,4.5,0,0,1-2.064-2.431l0-.025c-.59-1.934-1.292-4.635-2.071-7.823-.018-.027-.018-.027-.016-.052l-.034-.081c-1.515-6.193-3.314-14.229-4.991-22.05-2.06-9.626-3.928-18.95-4.887-24.242-.077-.286-.905-4.14-.961-4.423-2.877-16.4,9.916-27.087,19.213-23.963.133.045.248.086.362.126,1.871.75,2.388,7.325,2.809,11.769s3.579,50.5,4.369,58.826a33.27,33.27,0,0,1,.162,3.732C403.815,372.758,397.816,375.014,393.721,373.787Z",
    transform: "translate(-376.709 -287.466)",
    fill: "#ffb9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2198",
    "data-name": "Path 2198",
    d: "M383.472,324.886l-1.754-3.969c0,.025,0,.025.018.05a76.33,76.33,0,0,1,1.258,15.2l0,.261c-.034.711-.065,1.47-.135,2.2l0,.167a13.525,13.525,0,0,0-.063,2.3v.047c.317,1.931,2.571-7.656,3.08-9.893.061-.284.1-.448.1-.448l-1.767-4.183Z",
    transform: "translate(-370.442 -245.615)",
    fill: "#ffb9b0"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2199",
    "data-name": "Path 2199",
    d: "M375.889,280.914s-12.039,15.294-10.8,30.662c.513,6.4,1.308,12.032,2.035,18.468.106.927,1.549,14.441,1.141,14.454,0,0,24.807,7.665,48.772-2.377,0-1.639,1.918-33.091-11.028-63.08A208.626,208.626,0,0,1,375.889,280.914Z",
    transform: "translate(-258.384 -166.519)",
    fill: "#5146af"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2200",
    "data-name": "Path 2200",
    d: "M412.656,280c-.095,4.381-2.427,7.048-5.77,10.74-.423.657-1.461,10.425-1.814,16.917-.185,3.379,1.258,5.5,0,5.779-4.813,4.2-22.155,7.6-30.111,1.868.833-7.062-2.33-22.619-4.464-30.529-.333-1.218-.626-2.247-.891-3.039-1.988-6.008-5.576-25.275-2.92-26.115.529-.167,1.351-.383,2.3-.671,4.158-1.254,10.3-3.408,10.3-3.408s3.6,10.661,12.973,11.949c5.114-2.107,4.664-8.574,4.6-11.548,1.673.461,2.409.921,7.593,2.456,1.452,2.1.2,6.467,2.546,12.987C407.592,269.01,412.771,274.667,412.656,280Z",
    transform: "translate(-257.451 -200.918)",
    fill: "#7762ef"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M399.354,238.707s.948,11.582-1.029,17.653c-1.463,4.5-7.471,8.691-12.5,8.635C372,265,369.518,246.21,369.59,245.3s20.4-8.793,20.4-8.793Z",
    transform: "translate(-252.639 -219.733)",
    fill: "#ffb9b0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M383.456,288.237",
    transform: "translate(-235.289 -155.014)",
    fill: "#f2f2f2"
  })), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836",
    transform: "translate(151.502 290.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M406.486,366.219c-4.923.887-10.184-.5-12.341-.124-1.783.3-6.362,1.466-8.075-.074s-1.438-6.976.531-7.7a7.068,7.068,0,0,0,1.279.308,13.463,13.463,0,0,0,5.828-.477c3.746,1.542,3.883,2.215,8.142,3.075a27.669,27.669,0,0,1,5.425,1.645C409.113,363.711,409.259,365.724,406.486,366.219Z",
    transform: "translate(-384.938 -358.151)",
    fill: "#5045af"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837",
    transform: "translate(102.905 286.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M380.353,370.5c-4.932-.831-8.054-3.559-10.211-3.935-1.781-.317-6.267-1.191-6.738-3.03-.349-1.366,1.006-7.05,3.1-7.066a7.185,7.185,0,0,0,1.1.723,13.49,13.49,0,0,0,5.646,1.52c3.005,2.717,2.908,3.4,6.625,5.643a27.663,27.663,0,0,1,4.55,3.383C385.873,369.146,383.133,370.964,380.353,370.5Z",
    transform: "translate(-363.35 -356.465)",
    fill: "#5045af"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838",
    transform: "translate(48.029 53.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M338.972,269.808l4.529-5.389,27.634,24.71s13.493-17.959,17.2-23.567c4.081-6.166,7.76-11.44,13.727-12.471,1.375.849-.464,22.995-1.182,23.531-8.338,6.238-24.562,26.358-29.721,27.4C365.2,305.233,338.972,269.808,338.972,269.808Z",
    transform: "translate(-338.972 -252.11)",
    fill: "#ffb9b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M380.193,252.655s-5.646.072-8.072,2.071-14.027,20.384-14.027,20.384a8.173,8.173,0,0,0,3.05,6.386,16.931,16.931,0,0,0,8.354,3.615s5.821-5.794,9.1-8.43c2.044-1.643,2.247,2.422,2.247,2.422l10.265-10.022Z",
    transform: "translate(-315.057 -252.655)",
    fill: "#7762ef"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M369.463,280.438c-.308-.164-.61-.342-.9-.518-1.585-.945-3.041-1.94-3.708-3.741-.961-2.6-1.423-6.578-.079-9.094.912-1.7,2.623-2.818,3.8-4.354,1.621-2.123,2.1-4.9,2.238-7.561a49.886,49.886,0,0,1,.538-7.98c.957-4.462,2.229-8.712,5.668-11.586,5.509-4.606,16.55-7.334,22.556-2.2,1.092.934,1.306,1.684,2.78,1.828a10.847,10.847,0,0,1,5.04,1.472c1.97,1.139,4.36,2.744,4.083,5.331a9.266,9.266,0,0,1-3.757,5.468,4.555,4.555,0,0,1-2.123.475c-2.341.045-4.284-1.477-6.582-1.231a4.376,4.376,0,0,0-2.881,1.6c-.828,1.022-.716,2.447-1.682,3.4-1.551,1.533-3.955,1.4-5.792,2.4a1.942,1.942,0,0,0-.792.653,2.085,2.085,0,0,0-.2.984l-.106,2.9c-.912-.4-1.006-1.7-1.758-2.35a2.089,2.089,0,0,0-2.634.169,4.417,4.417,0,0,0-1.27,2.526,7.258,7.258,0,0,0,.511,3.464c.6,1.972,2.292,3.748,3.656,2.445.99,1.456-.092,3.888-.128,5.533-.029,1.306,0,3.894,1.216,4.752,1.123.79,2.9.191,2.972,2.224.061,1.859-1.8,3.314-3.647,3.541a13.681,13.681,0,0,1-5.459-.952c-1.783-.529-3.737-.943-5.472-.268-1.051.408-1.958,1.2-3.073,1.382A4.812,4.812,0,0,1,369.463,280.438Z",
    transform: "translate(-259.709 -227.089)",
    fill: "#5045af"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M355.762,270.053s-6.494-5.207-6.938-6.632-.538-2.951-1.074-4.345a8.132,8.132,0,0,0-4.507-4.484c-1.628-.671-.831-1.222-2.575-.885-2.632.509-3.881,3.089-4.932,5.106-4.486,8.6,7.8,10.224,8.232,10.242.9.036,5.468,5.218,5.468,5.218",
    transform: "translate(-296.223 -198.342)",
    fill: "#ffb9b0"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    "data-name": "Group 840",
    transform: "translate(15.755 12.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M335.275,268.551l4.448,2.969a1.226,1.226,0,0,0,1.731-.392l9.772-16.374-5.792-3.264-10.49,15.35A1.225,1.225,0,0,0,335.275,268.551Z",
    transform: "translate(-312.006 -213.259)",
    fill: "#8484ef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    "data-name": "Group 839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M328.978,249.06l1.531,1.042,6.191-9.022-1.531-1.042c-2.177-1.486-5.328-.669-7.039,1.823h0C326.421,244.35,326.8,247.574,328.978,249.06Z",
    transform: "translate(-321.602 -228.516)",
    fill: "#c4c4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M325.4,265.21l28.476,4.323,6.5-9.479-14.37-24.879Z",
    transform: "translate(-323.682 -233.67)",
    fill: "#c4c4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M326.206,254.212l26.657,3.928,2.592-3.778-22.434-10.081Z",
    transform: "translate(-322.671 -222.277)",
    fill: "#bbbbf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M344,258.23h0a3.622,3.622,0,0,0,4.923-1.274l1.155-1.686a3.594,3.594,0,0,0-.592-5.033h0a3.623,3.623,0,0,0-4.923,1.274L343.4,253.2A3.591,3.591,0,0,0,344,258.23Z",
    transform: "translate(-302.093 -215.475)",
    fill: "#c4c4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M344.557,250.717,343.4,252.4a3.368,3.368,0,1,0,5.515,3.757l1.155-1.682a3.754,3.754,0,0,0,.236-.4,3.309,3.309,0,1,1-5.468-3.726A3.819,3.819,0,0,0,344.557,250.717Z",
    transform: "translate(-302.091 -214.679)",
    fill: "#bbbbf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M325.422,266.982h0a2.125,2.125,0,0,0,2.89-.747l19.535-28.465a2.112,2.112,0,0,0-.349-2.958h0a2.125,2.125,0,0,0-2.89.75l-19.535,28.465A2.112,2.112,0,0,0,325.422,266.982Z",
    transform: "translate(-324.635 -234.507)",
    fill: "#a4a4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M348,234.883,331.73,258.589a2.128,2.128,0,0,1-2.89.75,1.765,1.765,0,0,1-.5-.542l-3.266,4.759a1.978,1.978,0,1,0,3.239,2.208L347.848,237.3A2.242,2.242,0,0,0,348,234.883Z",
    transform: "translate(-324.635 -234.036)",
    fill: "#8484ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M340.5,260.91l1.844,1.256c2.719,1.855,6.654.835,8.788-2.276l1.832-2.668c2.134-3.111,1.659-7.136-1.06-8.989l-1.844-1.256c-2.719-1.855-6.654-.835-8.788,2.276l-1.832,2.668C337.3,255.032,337.777,259.057,340.5,260.91Z",
    transform: "translate(-307.789 -220.063)",
    fill: "#a4a4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M340.5,248.594l-2.742,4a2.028,2.028,0,0,0,.335,2.845l8.574,5.844a2.047,2.047,0,0,0,2.782-.72l2.742-4a2.047,2.047,0,0,1-2.782.72l-8.574-5.842A2.033,2.033,0,0,1,340.5,248.594Z",
    transform: "translate(-308.75 -216.882)",
    fill: "#8484ef"
  })))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M335.453,262.3a8.959,8.959,0,0,1,1.565-6.693,14.385,14.385,0,0,1,1.6-1.72,2.206,2.206,0,0,1,.961-.635,3.03,3.03,0,0,1,2.082.471,3.79,3.79,0,0,1,1.706,1.7c.475,1.166-.333,2.139-1.252,2.719a.47.47,0,0,0-.23.227c-.052.155.056.353.158.529a3.866,3.866,0,0,1,.66,2.222,1.3,1.3,0,0,1-1.529,1.144c-.335-.054-.783-.185-.894.072a.547.547,0,0,0-.007.29,2.379,2.379,0,0,1-.518,1.875.656.656,0,0,1-.412.259,1.089,1.089,0,0,1-.432-.059,5.868,5.868,0,0,1-1.522-.675",
    transform: "translate(-295.476 -198.846)",
    fill: "#ffb9b0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M343.989,263.8a34.078,34.078,0,0,1-.531-3.494,7.945,7.945,0,0,0-3.757-6.533.951.951,0,0,0-.61-.176.673.673,0,0,0-.5.585,1.809,1.809,0,0,0,.119.806c.263.826,1.436,2.377,1.074,3.228a9.662,9.662,0,0,0-.928,4.05c.041,1.236.617,3.242,2.08,3.444",
    transform: "translate(-291.431 -198.364)",
    fill: "#ffb9b0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x2: 5.729,
    y2: 13.508,
    transform: "translate(19.536)",
    fill: "none",
    stroke: "#c4c4f7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 11.742,
    y2: 8.8,
    transform: "translate(7.573 12.013)",
    fill: "none",
    stroke: "#c4c4f7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x2: 14.603,
    y2: 1.434,
    transform: "translate(0 28.377)",
    fill: "none",
    stroke: "#c4c4f7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850",
    transform: "translate(758.416 167.606)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849",
    transform: "translate(0 6.108)"
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M540.5,188.5s-5.245-3.7-5.432-5.254-3.843-7.852-5.013-9.106-7.318-3.383-8.629-3.573-8.838.452-7.9,1.479,5.808.653,6.744,1.216l.937.561s-.937,1.272-.563,2.039-1.607,1.954-.858,3.264-.3,1.222.367,2.591c1.108,2.258,3.942,3.516,4.691,2.9.563,1.337,2.713,4.065,4.727,3.879s6.911,4.4,6.911,4.4",
    transform: "translate(-513.442 -139.16)",
    fill: "#ffb9b0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M571.9,166.819c.178,3.523-.072,9.657.937,10.567s4.264.768,4.264.768-11.638,14.715-12.678,13.907-14.805-12.025-11.713-12.606,6.121-.455,6.033-2.055l-.263-4.8",
    transform: "translate(-464.876 -143.808)",
    fill: "#ffb9b0"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M589.946,239.331s-22.707,2.578-27.934,2.686-4.968-2.623-4.968-2.623c-.266-5.754-1.24-19.312-2.323-23.907-1.009-4.291-1.456-5.875-2.334-9.952-1.954-9.061-1.869-10.792-3.937-21.975l13.563-10.9s1.4,4.171,7.089,4.243c7.6.1,9.963-5.225,9.963-5.225l18.5,12.282,1.736,29.877-2.213,24.6",
    transform: "translate(-469.645 -137.732)",
    fill: "#fca70c"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M574.239,176.416a39.485,39.485,0,0,1-1.6,5.22c-1.2,3.118-2.967,4.237-6.265,4.315l-6.954.164c-1.778.043-3.994.1-5.43-1.146s-1.456-3.32-1.772-5.036q-.6-3.289-.986-6.616a97.294,97.294,0,0,1-.612-13.081,9.32,9.32,0,0,1,.155-1.79,1.3,1.3,0,0,1,.3-.657,1.459,1.459,0,0,1,.835-.322,71.357,71.357,0,0,1,13.144-.842c3.1.088,6.393.45,8.849,2.35,2.474,1.911,3.647,5.018,4.7,7.96.169.473.295,1.1-.115,1.391",
    transform: "translate(-466.954 -156.597)",
    fill: "#ffb9b0"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845",
    transform: "translate(34.701 99.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    "data-name": "Group 842",
    transform: "translate(10.085 79.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M538.476,239.469a49.523,49.523,0,0,0,1.355,6.06c.6,1.542,5.666.119,6-.878s-1.594-8.343-1.594-8.343",
    transform: "translate(-526.909 -236.308)",
    fill: "#ed9c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M554.024,241.584c.439,1.664.993,4.86.993,4.86l-5.065,2.2-.831-.779a9.367,9.367,0,0,1-2.809,2.24,21.044,21.044,0,0,1-4.9,1.36c-4.421.475-7.674-.356-7.937-.968-1.1-2.562,4.77-3.248,5.934-3.555a7.772,7.772,0,0,0,5.556-5.567c.259-1.342-.074-1.578.675-1.538a1.785,1.785,0,0,1,1.267.6,3.2,3.2,0,0,0,3.6.835,3.825,3.825,0,0,0,1.794-1.495A2.21,2.21,0,0,1,554.024,241.584Z",
    transform: "translate(-533.338 -231.965)",
    fill: "#38287c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M572.89,224.636a85.809,85.809,0,0,1-25.852.612c1.119,3.208,3.861,7.316,4.905,11.832,3.449,14.909,4.646,34.939,5.522,47.329,0,0-1.655,3.181-6.963.759-7.929-19.582-21.773-59.269-21.645-67.88.164-10.961,27.522-13.608,47.573-16.309",
    transform: "translate(-528.858 -200.626)",
    fill: "#453087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M606.169,202.886c6.305,4.6-34.948,21.946-34.948,21.946a68.693,68.693,0,0,1-13.52,1.29,9.854,9.854,0,0,1-1.006-2.557c-.243-1.2-.113-2.445-.322-3.647a8.48,8.48,0,0,0-4.122-5.556,18.549,18.549,0,0,0-6.742-2.184c-5.578-.9-15.316-.27-15.316-.27,12.4-9.139,37.767-10.335,49.583-11.087C582.037,204.55,605.264,202.227,606.169,202.886Z",
    transform: "translate(-527.188 -200.822)",
    fill: "#38287c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844",
    transform: "translate(20.758 91.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M544.286,243.515a49.572,49.572,0,0,0,.284,6.2c.324,1.625,5.56,1.1,6.062.176s-.124-8.491-.124-8.491",
    transform: "translate(-530.315 -241.403)",
    fill: "#ed9c80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M559.911,247.654c.144,1.718.135,4.959.135,4.959l-5.369,1.294-.684-.914a9.354,9.354,0,0,1-3.154,1.72,21.043,21.043,0,0,1-5.065.489c-4.435-.3-7.494-1.679-7.647-2.328-.637-2.713,5.259-2.373,6.458-2.472a7.774,7.774,0,0,0,6.436-4.52c.488-1.276.2-1.567.934-1.4a1.785,1.785,0,0,1,1.144.806,3.2,3.2,0,0,0,3.4,1.445,3.825,3.825,0,0,0,2.026-1.159A2.209,2.209,0,0,1,559.911,247.654Z",
    transform: "translate(-538.079 -237.601)",
    fill: "#38287c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M604.775,201.334a255.513,255.513,0,0,1-27.947.891c-3.57,0-30.568,5.065-33.15,9.639-4.248,7.525,2.771,51.505,2.121,82.991,0,0,3.237,2.7,8.962.162,1.423-15.467,10.562-51.955,4.257-68.99,14.884,1.974,26.892,3.937,40.421-.547,3.167-1.049,5.535-3.287,6.96-7.379C607.825,213.992,607.08,205.008,604.775,201.334Z",
    transform: "translate(-512.035 -200.181)",
    fill: "#453087"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846",
    transform: "translate(17.364 34.926)"
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M596.158,172.112s-3.244.178-3.876.23a29.808,29.808,0,0,0-8.018,1.517c-3.678,1.362-6.274,4.784-9.268,7.46-2.884,2.575-17.827,16.813-20.613,17.338s-27.254-16.242-27.254-16.242l-5.972,5.974s26.547,24.53,34.464,24.573c3.843.02,25.035-11.136,31.817-15.472Z",
    transform: "translate(-521.156 -172.112)",
    fill: "#fca70c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M555.681,199.849c-5.457.308-30.466-18.792-33.366-21.021l-1.159,1.159s26.547,24.53,34.464,24.573c3.2.016,18.446-7.726,27.362-12.818l2.31-1.339-1.384-8.248S561.478,199.522,555.681,199.849Z",
    transform: "translate(-521.156 -163.71)",
    fill: "#ce4a30",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_847",
    "data-name": "Group 847",
    transform: "translate(13.895 66.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M531.2,225.091h60.771l-10.9-35.522a4.67,4.67,0,0,0-4.464-3.3H523.391a3.027,3.027,0,0,0-2.895,3.917Z",
    transform: "translate(-518.682 -186.268)",
    fill: "#a4a4f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M531.373,225.091h59.855l-10.9-35.522a4.671,4.671,0,0,0-4.466-3.3H522.647a3.03,3.03,0,0,0-2.9,3.917l10.438,34.032A1.237,1.237,0,0,0,531.373,225.091Z",
    transform: "translate(-519.615 -186.268)",
    fill: "#7a74d1"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M587.93,189.779c-3.023,13.675-3.559,24.377-4.414,34.156-10.618,4.122-14.943,10.258-25.334,14.882,0,0-8.205-1.362-9.065,1.733-.5,1.785,9.605,3.206,9.605,3.206,9.63.045,35.027-6.992,36.745-7.465s6.724-32.756,6.924-50.276c.027-2.488-.061-5.189-1.616-7.129a9.34,9.34,0,0,0-3.133-2.319c-6.776-3.464-11.8-4.41-19.391-4.892",
    transform: "translate(-468.832 -137.732)",
    fill: "#ce4a30",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M563.229,203.336c-1.141-1.436-3.221-1.646-5.056-1.6a37.114,37.114,0,0,0-4.061.324c-.612.083-1.319.227-1.382.891s2.976,0,4.57.459a80.315,80.315,0,0,1-9.4.257,2.694,2.694,0,0,0-1.083.11.9.9,0,0,0-.608.824,1.123,1.123,0,0,0,.43.716,6.378,6.378,0,0,0,3.232,1.3,24.9,24.9,0,0,0,14.283-1.261",
    transform: "translate(-472.445 -100.132)",
    fill: "#ffb9b0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M582.222,189.523c-.25,14.619-1.288,21.309-1,35.928-7.339,1.569-17.5,9.878-27.889,14.5a5.488,5.488,0,0,0,.344,3.8c.792.29,35.05-8.05,37.773-10.56,2.451-2.26,5.7-29.661,5.9-47.181.027-2.488-.061-5.189-1.616-7.129a9.341,9.341,0,0,0-3.133-2.319c-6.776-3.464-11.8-4.41-19.391-4.892",
    transform: "translate(-463.784 -137.732)",
    fill: "#fca70c"
  })), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848",
    transform: "translate(39.301 81.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M548.144,198.3c.216,3.115-3.464,5.639-8.223,5.639s-8.793-2.523-9.011-5.639,3.464-5.641,8.223-5.641S547.926,195.183,548.144,198.3Z",
    transform: "translate(-530.901 -192.657)",
    fill: "none",
    stroke: "#a4a4f7",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 3.135,
    cy: 5.48,
    rx: 3.135,
    ry: 5.48,
    transform: "matrix(0.039, -0.999, 0.999, 0.039, 3.028, 8.559)",
    fill: "#a4a4f7"
  })))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M565.263,161.563c-.115-.547-1.328-.655-2.548-.5s-4.468.563-5.135,1.083-.63.894-.986.934-.374-.326-1.15-.666-2.652-.1-3.872.052-2.377.423-2.352.981a3.123,3.123,0,0,0,.488,1.684c.248.155.248.128,1.207,2.332a2.327,2.327,0,0,0,2.935,1.594c2.006-.437,2.132-2.722,2.287-3.676s.3-1.1.6-1.135.513.059.9.945.666,2.931,2.721,3.046c2.69.151,3.856-.77,4.23-2.494.5-2.339.39-2.348.592-2.559a12.742,12.742,0,0,1,2.01.171l-.045-.7A15.2,15.2,0,0,1,565.263,161.563Zm-9.77,4.707a2.342,2.342,0,0,1-1.983,2.454c-1.234.155-1.8-.5-2.467-2.08a4.087,4.087,0,0,1-.4-2.85c.209-.378.876-.365,2.406-.461s2.044-.131,2.292.545A8.311,8.311,0,0,1,555.493,166.27Zm8.77-1.29c-.254,1.7-.876,2.51-2.566,2.713-2.4.288-2.857-.657-3.21-1.8a8.321,8.321,0,0,1-.448-2.357c.074-.714.576-.81,2.084-1.094s3.523-.637,3.82-.322A4.076,4.076,0,0,1,564.263,164.98Z",
    transform: "translate(-468.682 -144.983)",
    fill: "#483a99"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M582.437,166.729a25.949,25.949,0,0,0-.669-3.6,11.485,11.485,0,0,0-5.614-7.359,17.952,17.952,0,0,0-12.7-1.265c-2.325.651-3.188,1.875-4.385,1.841a13.168,13.168,0,0,1-3.253-1.072c-9.088-3.266-7.564,5.63-6.6,8.072.43,1.081,2.49,1.868,2.764,2.316s.243,2.65.419,3.62a1.919,1.919,0,0,0,1.132,1.337s.05-2.863.095-3.251a3.606,3.606,0,0,1,1.344-2.683,8.34,8.34,0,0,1,3.269-.918,24.9,24.9,0,0,1,6.688,1.108c1.7,1.456,2.134,4.779,2.611,6.733.221.912.453,1.524.824,1.51.281-2.69,1.215-2.758,2.825-1.839.858.491,1.339,2.195,1.369,3.638a3.839,3.839,0,0,1-2.712,3.971c-.642.137,1.294,3.807,2.19,4.723a4.9,4.9,0,0,0,.948.833,4.345,4.345,0,0,0,1.094.405l1.3.353a3.4,3.4,0,0,0,1.785.153c.959-.27,1.466-1.288,1.9-2.186.709-1.472,1.526-2.9,2.107-4.43A26.311,26.311,0,0,0,582.437,166.729Z",
    transform: "translate(-469.612 -153.884)",
    fill: "#483a99"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856",
    transform: "translate(919.968 247.677)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M700.235,256.912H585.208l13.775-10.191V196.969a7.517,7.517,0,0,1,7.516-7.516h93.736a7.517,7.517,0,0,1,7.516,7.516V249.4A7.517,7.517,0,0,1,700.235,256.912Z",
    transform: "translate(-585.208 -189.453)",
    fill: "#d5d2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_855",
    "data-name": "Group 855",
    transform: "translate(22.831 9.703)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_228",
    "data-name": "Rectangle 228",
    width: 52.568,
    height: 5.03,
    transform: "translate(37.151)",
    fill: "#fff",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 52.568,
    height: 5.03,
    transform: "translate(37.151 7.514)",
    fill: "#fff",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 52.568,
    height: 5.03,
    transform: "translate(37.151 15.029)",
    fill: "#fff",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_231",
    "data-name": "Rectangle 231",
    width: 52.568,
    height: 5.03,
    transform: "translate(37.151 22.35)",
    fill: "#fff",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_232",
    "data-name": "Rectangle 232",
    width: 36.66,
    height: 5.03,
    transform: "translate(37.151 31.109)",
    fill: "#fff",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_854",
    "data-name": "Group 854"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_233",
    "data-name": "Rectangle 233",
    width: 33.021,
    height: 38.611,
    rx: 3.385,
    fill: "#a9adff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_234",
    "data-name": "Rectangle 234",
    width: 33.021,
    height: 4.145,
    transform: "translate(0 43.419)",
    fill: "#fff",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853",
    transform: "translate(3.984 8.646)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M612.9,211.286H600.92a1.494,1.494,0,0,1-1.443-1.1l-2.305-8.514a1.5,1.5,0,0,1,1.443-1.884h16.593a1.492,1.492,0,0,1,1.443,1.884l-2.305,8.514A1.494,1.494,0,0,1,612.9,211.286Z",
    transform: "translate(-597.12 -194.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851",
    transform: "translate(3.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M613.255,215.93H598.823a.3.3,0,0,1,0-.6H613.03l5.022-17.514a.3.3,0,0,1,.286-.216h3.14a.3.3,0,0,1,0,.6h-2.915l-5.022,17.514A.3.3,0,0,1,613.255,215.93Z",
    transform: "translate(-598.526 -197.604)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852",
    transform: "translate(2.182 18.927)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M601.581,207.757a1.746,1.746,0,1,1-1.747-1.745A1.747,1.747,0,0,1,601.581,207.757Z",
    transform: "translate(-598.089 -206.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 1.745,
    cy: 1.745,
    r: 1.745,
    transform: "translate(12.69)",
    fill: "#fff"
  }))))))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863",
    transform: "translate(598.105 142.915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M451.8,245.655H598.358l-17.552-12.984V152.489a9.574,9.574,0,0,0-9.576-9.574H451.8a9.574,9.574,0,0,0-9.576,9.574v83.59A9.576,9.576,0,0,0,451.8,245.655Z",
    transform: "translate(-442.228 -142.915)",
    fill: "#d5d2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862",
    transform: "translate(12.733 14.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857",
    transform: "translate(0 0)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    width: 66.976,
    height: 6.409,
    transform: "translate(66.976 6.409) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 66.976,
    height: 6.409,
    transform: "translate(66.976 15.982) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    width: 66.976,
    height: 6.409,
    transform: "translate(66.976 25.556) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_238",
    "data-name": "Rectangle 238",
    width: 66.976,
    height: 6.409,
    transform: "translate(66.976 34.884) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    width: 66.976,
    height: 6.409,
    transform: "translate(66.976 44.213) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_240",
    "data-name": "Rectangle 240",
    width: 66.976,
    height: 6.408,
    transform: "translate(66.976 61.164) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 114.308,
    height: 6.409,
    transform: "translate(114.308 71.258) rotate(180)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861",
    transform: "translate(72.237 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 42.072,
    height: 49.193,
    rx: 4.313,
    transform: "translate(42.072 49.193) rotate(180)",
    fill: "#c4c4f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 42.072,
    height: 5.281,
    transform: "translate(42.072 60.6) rotate(180)",
    fill: "#fff",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860",
    transform: "translate(3.339 11.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M490.166,171.843h15.267a1.906,1.906,0,0,0,1.839-1.407l2.935-10.844a1.9,1.9,0,0,0-1.837-2.4H487.229a1.9,1.9,0,0,0-1.837,2.4l2.935,10.844A1.906,1.906,0,0,0,490.166,171.843Z",
    transform: "translate(-476.619 -150.937)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M492.314,177.759H510.7a.379.379,0,1,0,0-.759H492.6l-6.4-22.313a.378.378,0,0,0-.365-.275h-4a.379.379,0,1,0,0,.759h3.714l6.4,22.313A.378.378,0,0,0,492.314,177.759Z",
    transform: "translate(-481.457 -154.413)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859",
    transform: "translate(10.263 24.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M493.2,167.349a2.223,2.223,0,1,0,2.222-2.224A2.222,2.222,0,0,0,493.2,167.349Z",
    transform: "translate(-477.031 -165.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M486.016,167.349a2.223,2.223,0,1,0,2.222-2.224A2.222,2.222,0,0,0,486.016,167.349Z",
    transform: "translate(-486.016 -165.125)",
    fill: "#fff"
  }))))))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870",
    transform: "translate(862.756 342.147)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 64.584,
    cy: 6.808,
    rx: 64.584,
    ry: 6.808,
    transform: "translate(19.297 311.956)",
    fill: "#eae6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M589.979,369.763c-.543,1.056-3.14,3.5-6.74,5.1s-11.222,2.361-6.985,3.777,9.173.558,11.676.158a50.454,50.454,0,0,1,7.877-.477c3.892-.025,3.924-.266,3.4-4.653C598.484,367.631,591.73,366.35,589.979,369.763Z",
    transform: "translate(-540.758 -60.661)",
    fill: "#9aa3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M617.756,369.407c-.216,1.218,1.513,4.91-1.583,7.62s-10.119,5.563-5.461,5.668a27.115,27.115,0,0,0,11.5-2.141c2.366-1.171.477-3.012,3.415-3.937,3.87-1.222,3.07-4.068,1.06-5.828C624.107,364.991,618.454,365.466,617.756,369.407Z",
    transform: "translate(-498.027 -62.497)",
    fill: "#9aa3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M637.859,340.785s9.275-27.268-17.038-49.729c0,0-14.1,5.614-25.393,6.292-8.894.534-13.407-.286-13.407-.286s-.75,24.224-.781,37.281Z",
    transform: "translate(-532.962 -156.807)",
    fill: "#4a41a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M580.3,338.118c-.509-12.192,12.71-10.594,17.586-1.486,10.08,18.833-3.719,62.207-5.542,82.76-1.9.734-5.072,1.306-6.979.434a4.873,4.873,0,0,1-2.028-2.242C583.629,392.372,580.845,351.154,580.3,338.118Z",
    transform: "translate(-534.154 -108.85)",
    fill: "#4a41a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M597.408,376.651c-1.522,4.979-18.4,10.215-17.027-7.906.606-8.036,2.222-52.415,2.533-56.692s1.029-10.531,3.1-11.312c10.339-3.9,28.627,9.617,25.906,25.681C610.1,337.16,600.56,366.328,597.408,376.651Z",
    transform: "translate(-534.134 -145.537)",
    fill: "#4a41a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M600.121,343.027c-4.079-11.5,9.176-13.534,16.692-6.449,17.6,16.591,18.286,55.683,22.6,75.862a15.437,15.437,0,0,1-7.7,2.2,2.751,2.751,0,0,1-2.1-1.074C622.468,389.393,604.486,355.323,600.121,343.027Z",
    transform: "translate(-510.293 -104.993)",
    fill: "#4a41a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M626.455,377.522c.461,5.184-13.606,15.9-19.141-1.407-2.456-7.676-12.969-53.036-14.286-57.117s-.957-12.509.666-14.009c8.117-7.5,26.439-.9,29.951,15C626,330.627,625.5,366.771,626.455,377.522Z",
    transform: "translate(-519.216 -143.241)",
    fill: "#4a41a3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M575.25,260.093c.48-.506.959-1.013,1.387-1.562,3.334-4.264,3.82-8.043,6.909-12.991a38.623,38.623,0,0,1,2.244-4.3,17.966,17.966,0,0,1,5.013-4.108c1.443-.756.2,2.424.2,2.424s1.225-1.776,2.409-1.65c.461.05.543,2.762.549,3.226a22.778,22.778,0,0,1-2.53,10.769,5.546,5.546,0,0,0-.862,2.447,5.47,5.47,0,0,0,2.908-1.432,3.513,3.513,0,0,1,3.043-.887,8.334,8.334,0,0,1-.585,1.272c-1.317,2.472-2.8,5.1-5.326,6.305-1.513.716-3.262.844-4.738,1.63-2.668,1.418-3.964,4.7-6.672,6.04",
    transform: "translate(-540.455 -224.411)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 11.523,
    height: 21.216,
    rx: 0.646,
    transform: "matrix(0.923, 0.386, -0.386, 0.923, 49.528, 13.18)",
    fill: "#5e5dbb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 9.661,
    height: 18.938,
    transform: "translate(50.236 14.711) rotate(22.698)",
    fill: "#b4b4db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M618.941,265.427a63,63,0,0,0-12.876,2.175c-9.162,2.751-12.314,6.994-15.479,8.748,6.148-7.811,13-24.377,13-24.377s-8.266-6.789-9.216-5.182-35.642,42.2-34.554,48.775c.448,2.71,4.464,5.389,8.014,5.268,9.837-.338,21.259-3.917,33.235-7.836,5.265-1.722,6.888,1.99,6.888,1.99",
    transform: "translate(-559.793 -212.497)",
    fill: "#7a74d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M576.76,262.122s-4.369,8.806-5.682,9.38,3.185-1.835,5.646-4.376,5.828-9.211,5.828-9.211C581.26,258.444,576.76,262.122,576.76,262.122Z",
    transform: "translate(-545.967 -198.27)",
    fill: "#6960c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M582.6,240.829a1.992,1.992,0,0,1,.619,1.387c.3,1.949.588,4.018-.169,5.839a8.418,8.418,0,0,1-2.35,2.989,18.385,18.385,0,0,1-3.577,2.445",
    transform: "translate(-538.105 -219.646)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M589.627,234.32c-2.319.669-3.543,3.66-4.331,5.709a31.769,31.769,0,0,0-1.731,7.7,10.572,10.572,0,0,0,.376,5.418,11.383,11.383,0,0,0,1.513,2.357,4.987,4.987,0,0,0,1.09,1.148,1.681,1.681,0,0,0,1.508.257c.723-.277,1.013-1.126,1.218-1.871,1.335-4.865,2.8-9.786,5.542-14.018",
    transform: "translate(-530.265 -227.79)",
    fill: "#170d54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M587.6,242.146c-.047-1.549-1.677-2.559-3.088-.954-1.17,1.326-1.481,3.847-1.547,5.709-.081,2.231,1.648,2.668,3.071,2.98",
    transform: "translate(-530.808 -220.211)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M578.716,263.109c2.861-3.28,11.938-8.689,24.071-8.3,8.358.263,31.124,1.643,33.668,7.235,1.3,2.859,2.7,32.132.792,42.224-1.432,7.591-5.094,26.392-5.094,30.93s2.438,6.483,1.3,7.8c-2.548,2.951-19.967,4.189-28.146,4.189-7.278,0-19.668-1.94-20.3-4.273-.932-3.46,1.421-3.332,1.74-6.96s1.236-27.182-.1-31.036c-2.411-6.96-3.581-18.31-5.495-23.459C579.7,277.55,575.858,266.389,578.716,263.109Z",
    transform: "translate(-537.406 -202.186)",
    fill: "#7a74d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M618.36,269.106c.867,1.805,6.758,11.278,6.758,11.278l.239,1.135a46.9,46.9,0,0,1-.6,5.061c-1.432,7.591-5.094,26.392-5.094,30.93s2.334,6.4,1.3,7.8c-2.008,2.722-34.854,8.842-33.238,1.243.146-.687,27.567-21.608,27.713-22.311,1.263-6,2.366-10.33,2.92-14.709C619.693,279,617.494,267.3,618.36,269.106Z",
    transform: "translate(-524.917 -184.501)",
    fill: "#6960c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M587.415,253.471s-.077,9.522-.459,9.907a15.013,15.013,0,0,1-2.267,1.274s1.342,8.275,3.415,7.66,15.769-7.53,15.769-7.53-1.943-.79-1.943-1.558,1.844-15.744,1.844-15.744",
    transform: "translate(-528.645 -211.324)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M598.92,234.777c-2,.545-7.255-.545-8.707,1.632s-2.722,7.438-3.266,8.89c-1.083,2.888-1.79,5.977-2.575,8.955-1.026,3.881-2.717,10.99,1.081,14.236a5.054,5.054,0,0,0,2.929,1.488c1.8.324,3.586.693,5.385,1.015,2.787.5,5.871,1.083,8.64.185,3.7-1.2,5.722-6.283,6.675-9.734l5.441-19.774Z",
    transform: "translate(-530.639 -227.218)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M587.036,260.162s-.8,37.157-2.314,59.76l5.466,7.534,3.755-9.437a287.324,287.324,0,0,0-3.552-57.6Z",
    transform: "translate(-528.604 -195.459)",
    fill: "#3b2e7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M585.191,260.013l.128.511a10.4,10.4,0,0,0,1.13,2.753h0l3.354.259s2.278-1.2,2.58-2.479-3.741-3.386-3.741-3.386l-.491.191a7.318,7.318,0,0,0-2.92,2.1Z",
    transform: "translate(-528.017 -198.574)",
    fill: "#3b2e7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M599.618,253.446a14,14,0,0,1,3.825,3.876c-1.724,3.944-5.621,10.952-9.914,14.144a19.38,19.38,0,0,0-6.805-8.507S598.419,260.877,599.618,253.446Z",
    transform: "translate(-526.099 -203.861)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M590.535,262.68a14.4,14.4,0,0,0-6.668,6.337,31.877,31.877,0,0,1,.9-11.762s2.746-3.514,3.7-3.586C588.076,258.144,590.535,262.68,590.535,262.68Z",
    transform: "translate(-529.91 -203.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868",
    transform: "translate(11.045 56.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M591.618,294.522c-4.153.626-5.688,2.17-8.03,4.482a.865.865,0,0,0-.349.691c.054.331.443.477.774.531,1.929.311,2.242-.923,4.045-1.675,1.218-.509,2.427-1.036,3.638-1.562",
    transform: "translate(-541.512 -208.868)",
    fill: "#f2a181"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_867",
    "data-name": "Group 867",
    transform: "translate(0 47.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864",
    transform: "translate(0 6.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M600.7,282.18l14.718,47.17a1.688,1.688,0,0,1-1.56,2.366l-30.71,2.695a2.846,2.846,0,0,1-2.573-1.983l-15.825-46.451c-.4-1.265,1.432-3.075,2.665-3.084l30.709-2.695A2.846,2.846,0,0,1,600.7,282.18Z",
    transform: "translate(-564.7 -280.197)",
    fill: "#e9e6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865",
    transform: "translate(0.045 7.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M599.671,282.727l14.513,46.443a1.689,1.689,0,0,1-1.56,2.368l-30.71,2.695a2.848,2.848,0,0,1-2.573-1.986l-14.513-46.44a1.689,1.689,0,0,1,1.56-2.368l30.707-2.695A2.85,2.85,0,0,1,599.671,282.727Z",
    transform: "translate(-564.72 -280.744)",
    fill: "#e0d9ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    "data-name": "Group 866",
    transform: "translate(10.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M569.348,281.651l1.09,4.072,14.363-1.269L583.62,280.4Z",
    transform: "translate(-569.348 -273.942)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M570.656,281.457c.3.948,1.438,4.606,1.438,4.606l6.857-.635-1.439-4.606a4.662,4.662,0,0,0-4.549-3.278C571.07,277.721,570.037,279.472,570.656,281.457Zm1.519-.095a1.575,1.575,0,0,1,1.294-2.195,2.621,2.621,0,0,1,2.553,1.839,1.574,1.574,0,0,1-1.294,2.195A2.615,2.615,0,0,1,572.175,281.363Z",
    transform: "translate(-567.937 -277.531)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M603.891,293.059c-3.221.671-11.807,3.233-12.71,3.658a38.029,38.029,0,0,0-5.475,4.048c-3.23,3.242-1.578,4.752-2.852,9.148a2.57,2.57,0,0,0-.079.7c0,.457.619.853,1.243.425.338.567,1.335.216,1.819-.4-.009.439.606.716,1.594.169.534-.295.439-.268,1.673-1.369a12.976,12.976,0,0,1,3.494-2.127,25.383,25.383,0,0,0,3.41-1.558c1.3-.858,3.629-1.063,4.777-4.786a3.71,3.71,0,0,1,1.792-1.79l5.25-3.291",
    transform: "translate(-542.084 -210.698)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2278",
    "data-name": "Path 2278",
    d: "M614.822,278.409c1.366,4.871,7.048,38.627,7.048,38.627l-32.008,23.182,2.663,7s38.3-12.858,41.315-21.649,2.877-48.5-7.76-62.425c-3.386-4.435-10.17-6.672-10.17-6.672",
    transform: "translate(-533.219 -256.472)",
    fill: "#7a74d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2279",
    "data-name": "Path 2279",
    d: "M589.042,298.458a20.568,20.568,0,0,0-2.235,1.72c-.914.964-1.6,2.03-2.58,3.183",
    transform: "translate(-540.269 -203.943)",
    fill: "none",
    stroke: "#f2a181",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2280",
    "data-name": "Path 2280",
    d: "M588.217,297.516a11.566,11.566,0,0,0-2.638,3.2,43.194,43.194,0,0,1-2.1,4.054",
    transform: "translate(-541.206 -205.122)",
    fill: "none",
    stroke: "#f2a181",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2281",
    "data-name": "Path 2281",
    d: "M586.75,296.754c-.311.5-1.628,1.736-1.893,2.256a20.393,20.393,0,0,0-1.823,5.211",
    transform: "translate(-541.763 -206.075)",
    fill: "none",
    stroke: "#f2a181",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2282",
    "data-name": "Path 2282",
    d: "M610.15,262.216c-1.254-.734-2.215-1.508-3.032-.306-.432.637-.7,1.517-1.434,1.736A1.481,1.481,0,0,1,604,262.457a4.3,4.3,0,0,1,.277-2.258q.756-2.431,1.51-4.865c.493-1.587.984-3.332.354-4.871a5.358,5.358,0,0,0-1.535-1.967,16.263,16.263,0,0,0-7.469-3.194,79.37,79.37,0,0,1-8.039-1.652,8.707,8.707,0,0,1-3.061-1.54,6.608,6.608,0,0,1-2.17-4.95,10.215,10.215,0,0,1,1.571-5.274,8.779,8.779,0,0,0,.8,1.83,6.8,6.8,0,0,1,1.465-2.3c.781,4.356,19.121,2.9,23.4,4.822,2.971,1.33,5.427,2.2,5.337,7.014a1.764,1.764,0,0,0,.581.765c2.632,2.418,3.773,5.36,4.1,9.725.405,5.344-2.706,11.127-5.756,15.533a9.91,9.91,0,0,1-2.265,2.708,6.009,6.009,0,0,1-4.261.963c-1.321-.252-3.928-.14-3.953-1.486-.018-.963,2.042-2.681,2.611-3.458",
    transform: "translate(-529.67 -231.419)",
    fill: "#3b2e7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2283",
    "data-name": "Path 2283",
    d: "M593.433,251.065a1.681,1.681,0,0,0,2.514,1.907,5.8,5.8,0,0,0,3.66-4.489c.432-2.312-.81-4.622-2.924-4.021a3.119,3.119,0,0,0-2,3.041",
    transform: "translate(-517.756 -215.221)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2284",
    "data-name": "Path 2284",
    d: "M585.947,250.5l5.884,1.083a8.2,8.2,0,0,1-5.961,2.2",
    transform: "translate(-527.168 -207.542)",
    fill: "#f2a181"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873",
    transform: "translate(435.195 256.157)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871",
    transform: "translate(24.454 22.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2285",
    "data-name": "Path 2285",
    d: "M380.722,208.866l7.882,3.967-3.941-9.67",
    transform: "translate(-380.722 -203.163)",
    fill: "#3939d3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M369.859,208.942c0,8.683,7.458,15.722,16.658,15.722s16.658-7.039,16.658-15.722-7.46-15.722-16.658-15.722S369.859,200.259,369.859,208.942Z",
    transform: "translate(-369.859 -193.22)",
    fill: "#3939d3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M375.447,198.565V209.8a1.177,1.177,0,0,0,1.767,1.02l9.732-5.619a1.177,1.177,0,0,0,0-2.039l-9.732-5.619A1.178,1.178,0,0,0,375.447,198.565Z",
    transform: "translate(-362.868 -188.008)",
    fill: "#fefefe"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878",
    transform: "translate(995.998 375.697)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_875",
    "data-name": "Group 875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_874",
    "data-name": "Group 874",
    transform: "translate(0.98 22.38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M627.3,261.967l-7.882,3.967,3.941-9.669",
    transform: "translate(-619.419 -256.265)",
    fill: "#3939d3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2289",
    "data-name": "Path 2289",
    d: "M652.3,262.043c0,8.682-7.458,15.722-16.658,15.722s-16.658-7.039-16.658-15.722,7.458-15.719,16.658-15.719S652.3,253.36,652.3,262.043Z",
    transform: "translate(-618.983 -246.323)",
    fill: "#3939d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_877",
    "data-name": "Group 877",
    transform: "translate(6.877 5.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    "data-name": "Group 876",
    transform: "translate(6.67)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2290",
    "data-name": "Path 2290",
    d: "M625.134,266.7c3.631.059,7.307.106,10.646-.113,1.056-.07,1.97-1.655.687-2.154a2.336,2.336,0,0,0,1.324-1.085,1.054,1.054,0,0,0-.644-1.416c1.261.295,1.756-1.591.774-2.2a2.762,2.762,0,0,0,1.063-1.607,1.576,1.576,0,0,0-.768-1.661,2.9,2.9,0,0,0-1.308-.214q-2.266-.014-4.529-.032c.41-2.229.531-4.66-.669-6.618-.362-.59-1.333-1.3-2.1-.842-.723.425-.522,1.483-.486,2.15a7.46,7.46,0,0,1-4.117,6.87S625.172,263.689,625.134,266.7Z",
    transform: "translate(-625.001 -248.617)",
    fill: "#fefefe"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 5.487,
    height: 8.913,
    transform: "translate(0 9.165)",
    fill: "#fefefe"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883",
    transform: "translate(731.438 257.39)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_879",
    "data-name": "Group 879",
    transform: "translate(19.174 3.744)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2291",
    "data-name": "Path 2291",
    d: "M512.1,201.643l5.75-6.212-7.879,1.543",
    transform: "translate(-509.975 -195.431)",
    fill: "#3939d3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2292",
    "data-name": "Path 2292",
    d: "M501.458,205.168c0,6.3,5.409,11.4,12.082,11.4s12.079-5.1,12.079-11.4-5.409-11.4-12.079-11.4S501.458,198.871,501.458,205.168Z",
    transform: "translate(-501.458 -193.768)",
    fill: "#3939d3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882",
    transform: "translate(5.309 3.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881",
    transform: "translate(4.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2293",
    "data-name": "Path 2293",
    d: "M505.845,208.548c2.379.041,4.786.077,6.974-.083.693-.049,1.29-1.2.45-1.562a1.577,1.577,0,0,0,.867-.786.787.787,0,0,0-.421-1.026c.826.214,1.15-1.155.507-1.6a2.023,2.023,0,0,0,.7-1.164,1.19,1.19,0,0,0-.5-1.207,1.731,1.731,0,0,0-.858-.153l-2.967-.025a7.454,7.454,0,0,0-.437-4.8c-.239-.428-.874-.939-1.38-.61-.473.308-.342,1.076-.317,1.56a5.512,5.512,0,0,1-2.7,4.982S505.87,206.362,505.845,208.548Z",
    transform: "translate(-505.757 -195.431)",
    fill: "#fefefe"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 3.595,
    height: 6.464,
    transform: "translate(0 6.646)",
    fill: "#fefefe"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884",
    transform: "translate(777.234 155.084)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2294",
    "data-name": "Path 2294",
    d: "M553.554,177.254a17.782,17.782,0,1,0-4.052,3.728l6.9,3.681Z",
    transform: "translate(-521.802 -148.321)",
    fill: "#3939d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2295",
    "data-name": "Path 2295",
    d: "M527.108,154.769a4.35,4.35,0,0,1,6.155.063l1.11,1.132,1.141-1.123a4.351,4.351,0,1,1,6.105,6.2l-4.232,4.169-.025.029a4.353,4.353,0,0,1-6.154-.065l-4.165-4.252A4.352,4.352,0,0,1,527.108,154.769Z",
    transform: "translate(-516.8 -141.811)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalMarketing);
export default __webpack_public_path__ + "static/media/digital-marketing.212860d80cf30c6b86dffc10a7f50e12.svg";
export { ForwardRef as ReactComponent };